<template>
  <div>
    <perfect-scrollbar class="wrapper">
      <table class="table">
        <tr>
          <th class="th-date">
            <span>Дата</span>
          </th>
          <th class="th-time">
            <span>Время</span>
          </th>
          <th class="th-name">
            <span>Имя</span>
          </th>
          <th class="th-phone">
            <span>Телефон</span>
          </th>
        </tr>
        <tr v-for="item in bookings" :key="item.username" class="row">
          <td>{{ getDate(item.start) }}</td>
          <td>{{ getTime(item.start) }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.phone }}</td>
        </tr>
      </table>
    </perfect-scrollbar>
  </div>
</template>

<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import { getDate, getTime } from "@/assets/js/utils/helpers";

export default {
  name: "BookingsForDeleteTable",
  components: {
    PerfectScrollbar,
  },
  props: {
    bookings: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getDate(value) {
      return getDate(value);
    },
    getTime(value) {
      return getTime(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  min-height: 256px;
  height: auto;
  padding: 0;
  background: #ffffff;
  border: 1px solid #ebebeb;
  border-radius: 8px;

  .table {
    width: 100%;
    border-collapse: collapse;

    th {
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #f0811e;
      text-align: left;
      border-bottom: 1px solid #f6b566;
      padding: 12px 12px 12px 16px;
    }

    .th-date {
      width: 120px;
      min-width: 120px;
      max-width: 120px;
    }

    .th-time {
      width: 100px;
      min-width: 100px;
      max-width: 100px;
    }

    .th-name {
      width: 152px;
      min-width: 152px;
      max-width: 152px;
    }

    .th-phone {
      width: 140px;
      min-width: 140px;
      max-width: 140px;
    }

    td {
      padding: 12px 12px 12px 16px;

      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #222222;
      text-align: left;
      border-bottom: 1px solid #ebebeb;
    }

    tr {
      position: relative;
      td:last-child {
        width: 16px;
      }
    }

    td {
      padding: 12px 16px;

      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #222222;
      text-align: left;
      border-bottom: 1px solid #ebebeb;
    }

    tr {
      position: relative;
      td:last-child {
        width: 16px;
      }
    }
  }
}

.row {
  &:hover {
    background: #fef6e8;
  }
}
</style>
